export { default } from "./KnowledgeEntityCard";
